import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { generalService } from '../services/general.service';
import { ActivatedRoute, Router, NavigationEnd,Params } from '@angular/router';
import { DataService } from '../utils/data.service';
import { MatDialog, MatOptionSelectionChange } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Documento } from '../models/documento';
import { PagoVentaService, ORIGEN_PANTALLA_CUENTAS_POR_COBRAR, ORIGEN_PANTALLA_VENTA, ORIGEN_PANTALLA_PAGOS } from './pago-venta.service';
import { Cliente } from '../models/cliente';
import { FormaPago } from '../models/forma-pago';
import { MetodoPago } from '../models/metodo-pago';
import { Usuario } from '../models/usuario';
import { PaymentWrapper } from '../models/payment-wrapper';
import { DetallePago } from '../models/detalle-pago';
import { DatosGeneralesSAE } from '../datos-generales-SAE';
import { ModalTicketComponent } from './modal-ticket/modal-ticket.component';
import { values } from 'core-js/core/dict';
import { ThrowStmt } from '@angular/compiler';


@Component({
  selector: 'app-pago-venta',
  templateUrl: './pago-venta.component.html',
  styleUrls: ['./pago-venta.component.scss'],
  providers: [generalService]
})
export class PagoVentaComponent implements OnInit, OnDestroy {

  private formaPagoService = 'formaPago/';
  private usuarioService = 'usuario/';
  private pagoService = 'pago/';
  private origen = '';
  private usuarioSession: Usuario = null;
  public btnGuardar = false;
  public ventasPorPagar: Documento[] = [];
  public cliente: Cliente = new Cliente();
  public registrosMetodoPago: FormaPago[] = [];
  public metodosPago: MetodoPago[] = [];
  public fechaMaximaPago = new Date();
  public fechaMinimaPago = new Date();
  public montoTotalSuperaDeuda = false;
  public mensajeMontoTotalSuperaDeuda = '';
  public registroEfectivoEnUso = false;
  public registroSaldoFavorEnUso = false;
  private seRegresoAPantallaAnterior = false;
  private saldoAFavorComoFormaPago = true;parametro
  private saldoAFavorValido = true;
  public datosGeneralesSAE: any;

  private organizationId = 0;
  public montoDeuda = 0;
  public montoSaldoAFavorDisponible = null;
  public total = 0;
  public totalCobrado = 0;
  public cambio = 0;
  public estatus: {nombre: string, valor: number} = {nombre: '', valor: 0};


  public parametroUrl:any;
  public clienteProveedor='';

  public opcionesSiNo: {nombre: string, valor: number}[] = [
    {nombre: 'Si', valor: 1},
    {nombre: 'No', valor: 0}
  ];
  public toCashOut = 1;

  public pago: PaymentWrapper = new PaymentWrapper();
  public formularioPagoVenta: FormGroup;

  public readonly METODO_PAGO_EFECTIVO = 'Efectivo';
  public readonly METODO_PAGO_SALDO_FAVOR = 'Saldo a Favor';

  private isInit = true;




  public funcionesActivadas: boolean = false;

  constructor(private _generalService: generalService,
              private pagoVentaService: PagoVentaService,
              private location: Location,
              private route: ActivatedRoute,
              private router: Router,
              public dataService: DataService,
              public dialog: MatDialog,
              private formBuilder: FormBuilder,
              public _activated : ActivatedRoute) {
                this.datosGeneralesSAE = DatosGeneralesSAE;
                //this.idCompraVenta = this.route.snapshot.paramMap.get('id');
                this.route.params.forEach((params: Params)=>{
                  this.parametroUrl = params['parametro'];
                  console.log(this.parametroUrl);
                });
              }

  ngOnInit() {
    this.buildForm();
    this.establecerCliente();
    this.establecerPantallaOrigen();
    this.establecerVentasPorPagar(); //manda llamar al back
    this.validarOrigenAcceso();
    //La siguiente llamada a función se requiere ejecutar una vez que termina establecerVentasPorPagar por lo tanto se comentarizo y se manda llamar en los success es decir cuando realmente termina lo que se requiere terminar primero
   // this.consultarMetodosPago(this.cliente.idCliente);//si manda al back
    this.consultarUsuarioEnSesion();
    this.validarCompraVenta();
  }

  ngOnDestroy() {
    this.pagoVentaService.restablecerValores();
    this.pagoVentaService.seModificaraVentaPorPagar((this.seRegresoAPantallaAnterior && this.origen === ORIGEN_PANTALLA_VENTA));
  }

  consultarMetodosPago(idCliente: number) {
    const esPantallaPagos = this.origen == ORIGEN_PANTALLA_PAGOS ? 1 : 0;
    this._generalService.metodoCall(this.formaPagoService + `consultarMetodosPago?idCliente=${idCliente ? idCliente : 0}&esPantallaPagos=${esPantallaPagos}`)
        .subscribe((metodosPago) => {
          this.metodosPago = metodosPago;

          if(esPantallaPagos === 1 && this.ventasPorPagar.length === 0){
            for (let i = 0; i < this.metodosPago.length; i++) {
              if (this.metodosPago[i].WAY_TO_PAY_ID == -1 || this.metodosPago[i].WAY_TO_PAY_ID == -2) {  
                this.metodosPago.splice(0, 1);  
              }
            }
          }

          this.establecerMontoDeuda();
        }, (error) => {
          console.log(error);
        });
  }

  buildForm() {
    this.formularioPagoVenta = this.formBuilder.group({
        fechaPago: this.formBuilder.control(new Date(), [Validators.required]),
        toCashOut: this.formBuilder.control(1, Validators.required) 
    });

    this.fechaMinimaPago.setDate(this.fechaMinimaPago.getDate() - 240);
  }

  establecerVentasPorPagar() {
    this.ventasPorPagar = this.pagoVentaService.obtenerVentasPorPagar();
    
    this.pago.tipo = 1;
    if (this.origen === ORIGEN_PANTALLA_CUENTAS_POR_COBRAR && this.ventasPorPagar.length === 0 && this.cliente) {
      this.consultarVentasConDeuda(this.cliente.idCliente);
    } else if (this.origen === ORIGEN_PANTALLA_PAGOS && this.ventasPorPagar.length === 0 && this.cliente) {
      this.consultarVentasDirectaPedidoConDeuda(this.cliente.idCliente);
    } else {
      this.consultarMetodosPago(this.cliente.idCliente);//Se manda llamar este método ya que se quito del ngOnInit y se requiere para el flujo
      this.pago.tipo = 0;
    }
  }

  consultarVentasConDeuda(idCliente: number) {
    this._generalService.metodoCall(`${this.pagoService}consultarVentasConDeuda?idCliente=${idCliente}`)
    .subscribe((ventasPorPagar) => {
      this.ventasPorPagar = ventasPorPagar;
       this.consultarMetodosPago(this.cliente.idCliente);//Se manda llamar este método ya que se quito del ngOnInit debido a que se requería que otras funciones que mandan llamar al back recibieran primero su respuesta antes de continunar con el código de js
    }, (error) => {
      console.log(error);
    });
  }

  consultarVentasDirectaPedidoConDeuda(idCliente: number) {
    this._generalService.metodoCall(`${this.pagoService}consultarVentasDirectaPedidoConDeuda?idCliente=${idCliente}`)
    .subscribe((ventasPorPagar) => {
      this.ventasPorPagar = ventasPorPagar;
       this.consultarMetodosPago(this.cliente.idCliente);//Se manda llamar este método ya que se quito del ngOnInit debido a que se requería que otras funciones que mandan llamar al back recibieran primero su respuesta antes de continunar con el código de js
    }, (error) => {
      console.log(error);
    });
  }

  establecerCliente() {
    this.cliente = this.pagoVentaService.obtenerCliente();
    if(this.cliente.idCliente === undefined){
      this.cliente = new Cliente();
      this.cliente.Nombre = 'Público General';
      this.cliente.idCliente = null; 
    }

    /*if (!this.cliente) {
      this.cliente = new Cliente();
      this.cliente.Nombre = 'Publico General';
      this.cliente.idCliente = null; // TODO: Cambiar el id por el valor que represente 'publico en general'
    }*/
  }

  /**
   * Valida que se haya accedido a esta pantalla desde Venta o Cuentas por Cobrar
   * ya que estas son las unicas que proveen ventas y clientes, en caso
   * contrario, se accedio desde ruta y se regresa a la pantalla anterior
   */
  validarOrigenAcceso() {
    //Versión previa
    if (!this.origen || (this.ventasPorPagar.length === 0 && !this.cliente)) {
      this.regresarPantallaAnterior();
    }

    //Versión nueva
    //if (this.origen !== null && this.origen !== undefined && this.ventasPorPagar.length > 0 && this.cliente !== null && this.cliente !== undefined) {
      ////this.regresarPantallaAnterior();
    //} else {
    //  this.regresarPantallaAnterior();
    //}
  }

  establecerPantallaOrigen() {
    this.origen = this.pagoVentaService.obtenerOrigen();
  }

  establecerMontoDeuda() { // TODO: Cambiar nombre a uno mas adecuado
    
    if ((this.origen === ORIGEN_PANTALLA_CUENTAS_POR_COBRAR || this.origen === ORIGEN_PANTALLA_PAGOS) &&  this.cliente.idCliente) {
      this.saldoAFavorComoFormaPago = !(this.origen === ORIGEN_PANTALLA_PAGOS && this.ventasPorPagar.length === 0);
      this.montoDeuda = this.cliente.DEBT ? this.cliente.DEBT : 0;

      if (this.montoDeuda < 0) { //Aquí entra cuando se trata de un pago para incrementar el saldo a favor de un cliente
        this.montoSaldoAFavorDisponible = Math.abs(this.montoDeuda);
        this.montoDeuda = 0;
      }
      else
      {//Aquí entra cuando se van a pagar deudas del Cliente
        this.montoDeuda = 0;
        this.ventasPorPagar.forEach((venta) => this.montoDeuda += venta.DEBT);
      }
    

    } else if (this.origen === ORIGEN_PANTALLA_VENTA && this.ventasPorPagar.length === 1 &&  this.cliente.idCliente) {
      // El origen es Ventas y el montoDeuda = a TOTAL de la Venta y al haber cliente, puede haber adeudos (totalPagado puede ser != montoDeuda)
      this.ventasPorPagar.forEach((venta) => this.montoDeuda += venta.TOTAL);
      if(this.cliente.DEBT < 0) {
          this.montoSaldoAFavorDisponible = Math.abs(this.cliente.DEBT ? this.cliente.DEBT : 0);
          //Fix: 2023/07/04: Corrección para que deje guardar ventas aún y que el cliente cuente con saldo a favor
          if( this.montoSaldoAFavorDisponible != 0)
          {
            this.montoSaldoAFavorDisponible  = 0;
          }
          //Fin del Fix
      }
    } else if (this.origen === ORIGEN_PANTALLA_VENTA && this.ventasPorPagar.length === 1 &&  !this.cliente.idCliente) {
      // El origen es Ventas y el montoDeuda = a TOTAL de la Venta y al NO TENER cliente, NO puede haber adeudos (totalPagado debe ser = montoDeuda)
      // Se pagan en el momento que se crea, no deberia poder editarse el pago ni aparecer en el Cuentas por Cobrar
      this.ventasPorPagar.forEach((venta) => this.montoDeuda += venta.TOTAL);    
      if(this.cliente.DEBT < 0) {
          this.montoSaldoAFavorDisponible = Math.abs(this.cliente.DEBT ? this.cliente.DEBT : 0);
      }
    } else {
      this.regresarPantallaAnterior();
    }
    
    this.montoDeuda = parseFloat(this.montoDeuda.toFixed(2));
    this.initPago();
  }

  public hayFaltante: boolean;
  initPago() {
    let efectivoArray: any[];
    if(this.metodosPago.filter((obj) => { return obj.NAME === "Saldo a Favor"; })){
      efectivoArray = this.metodosPago.filter((obj) => { return obj.NAME === "Saldo a Favor"; });
    }else {
      efectivoArray  = this.metodosPago.filter((obj) => { return obj.NAME === "Efectivo"; });
    }


    if (efectivoArray.length == 0) {
      efectivoArray  = this.metodosPago.filter((obj) => { return obj.NAME === "Efectivo"; });
      //efectivoArray.push({CASH: 1, NAME: 'Efectivo', WAY_TO_PAY_ID: 1});
    } 
    const registrosMetodoPago = new FormaPago();
    registrosMetodoPago.idFormaPago = this.registrosMetodoPago.length + 1;

    this.registrosMetodoPago.push(registrosMetodoPago);
    this.formularioPagoVenta.addControl('metodoPago' + registrosMetodoPago.idFormaPago,
                                        this.formBuilder.control(0, [Validators.required]));
    this.formularioPagoVenta.addControl('monto' + registrosMetodoPago.idFormaPago,
                                        this.formBuilder.control(0, [Validators.required]));
    

    this.formularioPagoVenta.controls['metodoPago' + (registrosMetodoPago.idFormaPago)].setValue(efectivoArray[0]);

    let montoCobrar:number;
    if (this.montoSaldoAFavorDisponible > 0) {
      if (this.montoSaldoAFavorDisponible > this.montoDeuda) {
        montoCobrar = this.montoDeuda;
        this.hayFaltante = false;
      } else {
        montoCobrar = this.montoSaldoAFavorDisponible;
        this.hayFaltante = true;
      }
    } else {
      montoCobrar = this.montoDeuda;
      this.hayFaltante = false;
    }
    this.formularioPagoVenta.controls['monto' + (registrosMetodoPago.idFormaPago)].setValue(montoCobrar);

    this.registroSaldoFavorEnUso = true;

    if (this.hayFaltante) {
      this.agregarFormaDePago();
      let ultimoRegistro = this.registrosMetodoPago.length;
      let efectivoFaltante: any[];
      efectivoFaltante  = this.metodosPago.filter((obj) => { return obj.NAME === "Efectivo"; });
      let montoFaltante = this.montoDeuda - this.montoSaldoAFavorDisponible;
      montoFaltante = parseFloat(montoFaltante.toFixed(2));

      this.formularioPagoVenta.controls['metodoPago' + ultimoRegistro].setValue(efectivoFaltante[0]);
      this.formularioPagoVenta.controls['monto' + ultimoRegistro].setValue(montoFaltante);
      this.registroEfectivoEnUso = true;

      this.hayFaltante = false;

      //registrosMetodoPago.idFormaPago = 2;
      //let efectivoFaltante: any[];
      //efectivoFaltante  = this.metodosPago.filter((obj) => { return obj.NAME === "Efectivo"; });
      //let montoFaltante = this.montoDeuda - this.montoSaldoAFavorDisponible;

      //this.registrosMetodoPago.push(registrosMetodoPago);
      //this.formularioPagoVenta.addControl('metodoPago' + registrosMetodoPago.idFormaPago,
       //                                   this.formBuilder.control(efectivoFaltante[0], [Validators.required]));
      //this.formularioPagoVenta.addControl('monto' + registrosMetodoPago.idFormaPago,
      //                                    this.formBuilder.control(montoFaltante, [Validators.required]));

      //this.formularioPagoVenta.controls['metodoPago' + (pagoFaltante.idFormaPago)].setValue(efectivoFaltante[0]);
      //this.formularioPagoVenta.controls['monto' + (pagoFaltante.idFormaPago)].setValue(montoFaltante.valueOf());
    }

    this.calcularMontos();
  }

  consultarUsuarioEnSesion() {
    const datosUsuario: any = {};
    datosUsuario.loacs = sessionStorage.getItem('acslo');
    this._generalService.metodoCallParams(datosUsuario, this.usuarioService + 'consultarUsuarioSession')
        .subscribe((usuario) => {
          this.usuarioSession = JSON.parse(usuario)[0];
          this.establecerEstatus();
        }, (error) => {
          console.log(error);
        });
  }

  establecerEstatus() {
    if (!this.usuarioSession.ADMIN || this.usuarioSession.ADMIN === 0) {
      this.estatus.nombre = 'Por aprobar';
      this.estatus.valor = 0;
      this.pago.usuarioEsAdmin = false;
    } else if (this.usuarioSession.ADMIN === 1) {
      this.estatus.nombre = 'Aprobado';
      this.estatus.valor = 1;
      this.pago.usuarioEsAdmin = true;
    }
  }

  agregarFormaDePago() {
    const registrosMetodoPago = new FormaPago();

    if (this.registrosMetodoPago.length > 0) {
      registrosMetodoPago.idFormaPago = this.registrosMetodoPago[this.registrosMetodoPago.length - 1].idFormaPago + 1;
    } else {
      registrosMetodoPago.idFormaPago = this.registrosMetodoPago.length + 1;
    }

    this.registrosMetodoPago.push(registrosMetodoPago);
    this.formularioPagoVenta.addControl('metodoPago' + registrosMetodoPago.idFormaPago,
                                        this.formBuilder.control(0, [Validators.required]));
    this.formularioPagoVenta.addControl('monto' + registrosMetodoPago.idFormaPago,
                                        this.formBuilder.control(0, [Validators.required]));

    this.formularioPagoVenta.controls['metodoPago' + (registrosMetodoPago.idFormaPago)].reset();
    this.formularioPagoVenta.controls['monto' + (registrosMetodoPago.idFormaPago)].reset();
  }

  eliminarFormaDePago(formaPago: FormaPago, indiceFormaPago) {
    this.registrosMetodoPago.splice(indiceFormaPago, 1);
    const metodoPago = this.formularioPagoVenta.controls['metodoPago' + (formaPago.idFormaPago)].value;

    if (metodoPago && metodoPago.NAME === this.METODO_PAGO_EFECTIVO) {
      this.registroEfectivoEnUso = false;
    } else if (metodoPago && metodoPago.NAME === this.METODO_PAGO_SALDO_FAVOR) {
      this.registroSaldoFavorEnUso = false;
    }

    this.formularioPagoVenta.removeControl('metodoPago' + (formaPago.idFormaPago));
    this.formularioPagoVenta.removeControl('monto' + (formaPago.idFormaPago));

    this.totalCobrado = parseFloat(this.calcularMonto().toFixed(2));
    this.calcularMontos();
  }

  actualizarMonto(opcion: MatOptionSelectionChange, formaPago: FormaPago) {
    if (opcion.isUserInput) {
      if(this.isInit) {
        this.isInit = false;
        return;
      }
      formaPago.idWayToPay = opcion.source.value.WAY_TO_PAY_ID;
      formaPago.nombre = opcion.source.value.NAME;
      this.validarRegistroEfectivoEnUso();
      //this.validarRegistroSaldoFavorEnUso();
      
      
      //this.formularioPagoVenta.controls['monto' + (formaPago.idFormaPago)].reset();
      
    }
  }

  validarRegistroEfectivoEnUso() {
    const metodoPagoEfectivo = this.metodosPago.filter((metodoPago) => metodoPago.NAME === this.METODO_PAGO_EFECTIVO)[0];
    const registrosEfectivo = this.registrosMetodoPago.filter((idFormaPago) => idFormaPago.idWayToPay === metodoPagoEfectivo.WAY_TO_PAY_ID);
    this.registroEfectivoEnUso = registrosEfectivo.length >= 1;
  }

  validarRegistroSaldoFavorEnUso() {
    const metodoPagoSaldoFavorFiltro = this.metodosPago.filter((metodoPago) => metodoPago.NAME === this.METODO_PAGO_SALDO_FAVOR);

    if (metodoPagoSaldoFavorFiltro.length > 0) {
      const metodoPagoSaldoFavor = metodoPagoSaldoFavorFiltro[0];
      const registrosSaldoFavor = this.registrosMetodoPago.filter((idFormaPago) => idFormaPago.idWayToPay === metodoPagoSaldoFavor.WAY_TO_PAY_ID);
      //this.registroSaldoFavorEnUso = registrosSaldoFavor.length >= 1;
    }
  }

  validarMonto(formaPago: FormaPago) {
    const metodoPago = this.formularioPagoVenta.controls['metodoPago' + (formaPago.idFormaPago)].value;
    const monto = this.formularioPagoVenta.controls['monto' + (formaPago.idFormaPago)].value;

    if (metodoPago && metodoPago.NAME !== this.METODO_PAGO_EFECTIVO) {
      let error = null;
      if (monto > this.montoDeuda && !(this.origen === ORIGEN_PANTALLA_PAGOS && this.ventasPorPagar.length == 0)) {
        error = {exceso: true};
      } else if (monto <= 0) {
        error = {cero: true};
      }
      this.formularioPagoVenta.controls['monto' + (formaPago.idFormaPago)].setErrors(error);
    }

    if (metodoPago && (metodoPago.NAME !== this.METODO_PAGO_SALDO_FAVOR || this.saldoAFavorComoFormaPago)) {
      this.calcularMontos();
    }
  }

  calcularMontos() {
    this.cambio = 0;
    this.totalCobrado = parseFloat(this.calcularMonto().toFixed(2));
    const montoEfectivo = this.obtenerMontoEfectivo();
    const cambioEstimado = this.totalCobrado - this.montoDeuda;

    if (cambioEstimado > 0) {
      if (montoEfectivo > cambioEstimado) {
        this.cambio = (this.montoDeuda <= 0)? 0 : parseFloat((this.totalCobrado - this.montoDeuda).toFixed(2));
      }
    }

    this.total = parseFloat((this.totalCobrado - this.cambio).toFixed(2));
  }

  obtenerMontoEfectivo() {
    let montoEfectivo = 0;
    this.registrosMetodoPago.forEach((registrosMetodoPago) => {
      const monto =
      this.formularioPagoVenta.controls['monto' + (registrosMetodoPago.idFormaPago)].value;

      const metodoPago =
      this.formularioPagoVenta.controls['metodoPago' + (registrosMetodoPago.idFormaPago)].value;

      if (metodoPago && metodoPago.NAME === this.METODO_PAGO_EFECTIVO) {
        montoEfectivo += monto;
      }
    });
    return montoEfectivo;
  }

  obtenerMontoNoEfectivo() {
    let montoTotal = 0;
    this.registrosMetodoPago.forEach((formaPago) => {
      const monto =
      this.formularioPagoVenta.controls['monto' + (formaPago.idFormaPago)].value;

      const metodoPago =
      this.formularioPagoVenta.controls['metodoPago' + (formaPago.idFormaPago)].value;

      if (metodoPago && metodoPago.NAME !== this.METODO_PAGO_EFECTIVO) {
        montoTotal += monto;
      }
    });
    return montoTotal;
  }

  calcularMonto() {
    let monto = 0;
    this.registrosMetodoPago.forEach((formaPago) => {
      if (formaPago.nombre !== this.METODO_PAGO_SALDO_FAVOR || this.saldoAFavorComoFormaPago) {
        monto += this.formularioPagoVenta.controls['monto' + (formaPago.idFormaPago)].value;
      }
    });

    return monto;
  }

  validarFormularioPagoVenta() {
    
    console.log("Entra al método validarFormularioPagoVenta");
    //this.datosGeneralesSAE.showSpinnerLoading = true; 20/Abril se comentarizo
    this.resaltarCamposConErrores();
    
    if (this.saldoAFavorComoFormaPago) {
      // TODO: Validaciones para saldo a favor como metodo pago
      this.validarMontosExcedente();
      this.validarMontoDeudaTotalPagado();
    } else {
      // this.validarMontosCubrenSaldoAFavor();
    }

    // if (this.formularioPagoVenta.valid && this.montoDeuda === 0) {
    //   this._generalService.toastCall("No hay deudas por cubrir");
    // } else if (this.formularioPagoVenta.valid && this.registrosMetodoPago.length > 0 && !this.montoTotalSuperaDeuda && this.saldoAFavorValido) {
    //     this.guardarPagoVenta();    
    // }

    if (this.formularioPagoVenta.valid && this.registrosMetodoPago.length > 0 && !this.montoTotalSuperaDeuda && this.saldoAFavorValido) {
      this.btnGuardar = true;
      this.guardarPagoVenta();    
    }
  }

  resaltarCamposConErrores() {
    Object.keys(this.formularioPagoVenta.controls).forEach((key) => {
      this.formularioPagoVenta.get(key).markAsTouched();
    });
    //this.datosGeneralesSAE.showSpinnerLoading = false; 20/Abril se comentarizo
  }

  /**
   * Valida que al agregar saldo a favor, los demas metodos
   * de pago cubran el monto que se quiere agregar como saldo.
   */
  validarMontosCubrenSaldoAFavor() {
    let totalMontos = 0;
    let montoSaldoAFavor = 0;
    this.registrosMetodoPago.forEach((formaPago) => {
      const monto = this.formularioPagoVenta.controls['monto' + (formaPago.idFormaPago)].value;

      if (formaPago.nombre !== this.METODO_PAGO_SALDO_FAVOR) {
        totalMontos += monto;
      } else {
        montoSaldoAFavor += monto;
      }
    });

    this.saldoAFavorValido = totalMontos === montoSaldoAFavor;

    if (!this.saldoAFavorValido) {
      this._generalService.toastCall('Se debe cubrir el monto de Saldo a Favor con los demas Métodos de Pago');
    }
  }

  validarMontosExcedente() {
   // this.datosGeneralesSAE.showSpinnerLoading = true; 20/Abril se comentarizo
    this.totalCobrado = parseFloat(this.calcularMonto().toFixed(2));
    const montoNoEfectivo = this.obtenerMontoNoEfectivo();
    const montoEfectivo = this.obtenerMontoEfectivo();
    const cambioEstimado = this.totalCobrado - this.montoDeuda;

    this.mensajeMontoTotalSuperaDeuda = 'La Suma de los Montos que no son Efectivo son mayor al Monto de la Deuda';
    this.montoTotalSuperaDeuda = (montoNoEfectivo > this.montoDeuda);

    if (cambioEstimado > 0) {
      if (!this.montoTotalSuperaDeuda) {
        this.mensajeMontoTotalSuperaDeuda = 'El Monto Total es mayor al Monto de la Deuda';
        this.montoTotalSuperaDeuda = (this.totalCobrado - this.cambio) > this.montoDeuda;
      }
    }

    if (this.montoTotalSuperaDeuda) {
      this._generalService.toastCall(this.mensajeMontoTotalSuperaDeuda);
    }
    //this.datosGeneralesSAE.showSpinnerLoading = false; 20/Abril se comentarizo
  }

  /**
   * Valida que en caso de no tener cliente, se deba cubrir el total de la deuda
   */
  validarMontoDeudaTotalPagado() {
    //this.datosGeneralesSAE.showSpinnerLoading = true; 20/Abril se comentarizo
    if (!this.cliente.idCliente && this.totalCobrado < this.montoDeuda) {
      this.formularioPagoVenta.setErrors({invalid: true});
      this._generalService.toastCall('No es posible guardar el pago, se debe pagar el 100% de la deuda');
      //this.datosGeneralesSAE.showSpinnerLoading = false; 20/Abril se comentarizo
    } else {
      this.formularioPagoVenta.setErrors(null);
      //this.datosGeneralesSAE.showSpinnerLoading = false; 20/Abril se comentarizo
    }
  }

  guardarPagoVenta() {
    
    console.log("Entra al método guardarPagoVenta");
    //this.datosGeneralesSAE.showSpinnerLoading = true; 20/Abril se comentarizo
    this.establecerPago();

    if (this.pago.seAgregaSaldoAFavor) {
      this.pago.detallesPago.push(this.obtenerRegistroSaldoAFavor());
    }

    this._generalService.metodoCallParams(this.pago, this.pagoService + 'pagarVenta', true)
    .subscribe((idPayment) => {
      this.mostrarModalTicket(idPayment);
      this.btnGuardar = false;
    }, (error) => {
      console.log(error);
    });
  }

  obtenerRegistroSaldoAFavor() {
    const detallePago = new DetallePago();
    detallePago.metodoPago = new MetodoPago();
    detallePago.metodoPago.NAME = this.METODO_PAGO_SALDO_FAVOR;
    detallePago.monto = this.pago.total;
    return detallePago;
  }

  mostrarModalTicket(idPayment: number) {
    console.log("Entra al método mostrarModalTicket");
    if(idPayment!==0){
        const dialogRef = this.dialog.open(ModalTicketComponent,
          {disableClose: true
        });

        dialogRef.afterClosed().subscribe((imprimirTicket) => {
          //this.datosGeneralesSAE.showSpinnerLoading = false; 20/Abril se comentarizo
          if (imprimirTicket) {
            this.mostrarModalTicket(idPayment);
            this.crearTicketPago(idPayment);
          } else {
            this.cerrarPagoVenta();
          }
        });
    }
    else
    {
      this.cerrarPagoVenta();
    }
  }

  cerrarPagoVenta() {
    let mensajeExito = '';
    let ventaCompra = '';
    
    if(this.parametroUrl == ':parametro'){
      ventaCompra='compra'
    }else{
      ventaCompra='venta'
    }
    if (this.origen === ORIGEN_PANTALLA_CUENTAS_POR_COBRAR || this.origen === ORIGEN_PANTALLA_PAGOS) {
      mensajeExito = 'El pago se ha registrado correctamente';
      this.redirigirACuentasPorCobrar(mensajeExito);
    } else if (this.origen === ORIGEN_PANTALLA_VENTA) {
      if (this.cliente.Nombre === 'Publico General') {
        mensajeExito = 'El pago se ha registrado correctamente';
        this.redirigirAHistorialDeVentas(mensajeExito);
      } else {

        mensajeExito = 'La ' + ventaCompra + ' y el pago se han registrado correctamente';
        this.redirigirAHistorialDeVentas(mensajeExito);
      }
    }
  }

  redirigirACuentasPorCobrar(mensaje: string) {
    this._generalService.toastCall(mensaje);
    this.router.navigate([`/app/historial-pagos/${this.cliente.idCliente}`]);
  }

  redirigirAHistorialDeVentas(mensaje: string) {
    this._generalService.toastCall(mensaje);
    if(this.parametroUrl == ':parametro'){
      this.router.navigate([`/app/compra/:parametro`]);
    }else{
      this.router.navigate([`/app/venta`]);
    }
    
  }

  establecerPago() {
    this.pago.toCashOut = this.formularioPagoVenta.controls['toCashOut'].value;
    this.pago.idUsuario = this.usuarioSession.USER_ID;
    this.pago.cliente = this.cliente;
    this.pago.ventas = this.ventasPorPagar;
    this.pago.ventaUnica = null;
    this.pago.fechaPago = this.formularioPagoVenta.controls['fechaPago'].value;
    this.pago.total = this.total;
    this.pago.totalCobrado = this.totalCobrado;
    this.pago.cambio = this.cambio;
    this.pago.detallesPago = this.obtenerDetallesPago();
    this.pago.seAgregaSaldoAFavor = this.montoDeuda === 0 && this.ventasPorPagar.length === 0;

    this.organizationId = this.ventasPorPagar.length == 0? this.usuarioSession.ORGANIZATION_ID : this.pago.ventas[0].ORGANIZATION_ID;
    if (this.origen === ORIGEN_PANTALLA_VENTA) {
      this.pago.ventas = [];
      this.pago.ventaUnica = this.pagoVentaService.obtenerVentaAAgregar();
      this.organizationId = this.pago.ventaUnica.ORGANIZATION_ID; 
    }

    this.pago.organizationId = this.organizationId;
  }

  obtenerDetallesPago(): DetallePago[] {
    const detallesPago: DetallePago[] = [];

    this.registrosMetodoPago.forEach((registroMetodoPago) => {

      if (registroMetodoPago.nombre !== this.METODO_PAGO_SALDO_FAVOR || this.saldoAFavorComoFormaPago) {        
        const metodoPago = this.formularioPagoVenta.controls[`metodoPago${registroMetodoPago.idFormaPago}`].value;
        const monto = this.formularioPagoVenta.controls[`monto${registroMetodoPago.idFormaPago}`].value;
  
        const detallePago = new DetallePago();
        detallePago.metodoPago = metodoPago;
        detallePago.monto = monto;
  
        detallesPago.push(detallePago);
      }

    });
    return detallesPago;
  }

  consultarVenta(venta: Documento) {
    window.open(`#/app/venta/${venta.DOCUMENT_ID}`, '_blank');
  }

  regresarPantallaAnterior() {
    this.seRegresoAPantallaAnterior = true;
    this.pagoVentaService.seModificaraVentaPorPagar(true);
    this.location.back();
  }

  crearTicketPago(idPayment: any){
    this.datosGeneralesSAE.showSpinnerLoading = true;
    console.log("única linea que muestra el spinner");
    var bandera = false;
    if(this.parametroUrl == ':parametro'){
      bandera=true;
    }
    // Se consulta la información y configuración del ticket en base al pago y sucursal
    this._generalService.requestGet("pago/crearTicketPago?idOrganization=" + this.organizationId + "&idPayment=" + idPayment + "&bandera=" + bandera ).subscribe(
        (result) => {

            // El primer paso para imprimir el ticket es transformar la base64 a un arreglo de bytes con el cual se obtendrá un 
            // objeto blob
            const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];
                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
            const blob = b64toBlob(result, "application/pdf");

            // Se crea una url valida con el objeto blob
            const blobUrl = URL.createObjectURL(blob);

            // Se elimina el iframe del ticket si ya había sido creado uno
            if (document.getElementById("iframeTicket") != null){
                $("#iframeTicket").remove();
            }

            // Se crea un iframe para el ticket y se le pone como src el url creado apartir del blob
            var iframe: any = document.createElement('iframe');
            iframe.id = "iframeTicket";
            iframe.style.display = 'none';
            iframe.src = blobUrl;
            document.body.appendChild(iframe);

            // Se pone en un timeout en lo que se espera a que se agrege al body del document y se pueda imprimir
            console.log("Va a entrar al timeout");
            setTimeout(()=>{    
                // Se imprime el ticket
                iframe.focus();
                iframe.contentWindow.print();

                this.datosGeneralesSAE.showSpinnerLoading = false;
                console.log("Despues de ocultar el spinner dentro del timeout");
           }, 100);
            console.log("Despues del timeout");

        },
        (error) => {
            const errorMsj =  error as any;
            console.error(errorMsj);
        }
    );

  }

  inputNumerosConDecimales(e: any, formaPago: FormaPago, decimales: number): boolean {
        var valor = this.formularioPagoVenta.controls['monto' + (formaPago.idFormaPago)].value;

        // Verifica que la tecla ingresada fuera copiar, pegar, eliminar, numeros o puntos decimales
        if ([8, 9, 13, 27, 46, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) || 
            (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) || 
            (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) || 
            (e.keyCode === 88 && e.ctrlKey === true)) {

            const character = String.fromCharCode(e.keyCode);
            valor = (valor) ? valor : '';
            const newValue: any = valor + character;
            // Verifica que no tenga más de un punto y que solo cuente con las decimales que se establecio en el input
            if (isNaN(newValue) || this.hasDecimalPlace(newValue, decimales)) {
                e.preventDefault();
                return false;
            }
            else{
                return;
            }
        }
        else{
            e.preventDefault();
            return false;
        }
    }

    hasDecimalPlace(value: any, decimales: any) {
        // Verifica que solo cuente con las decimales que se establecio en el input
        const ed = value.split(".");
        if(ed.length > 1){
            return ed[1].length > 2;
        }
        else{
            return false;
        }
    }

     // -------------- FUNCIONES SECUNDARIAS ---------------
    activarFunciones(){

        this.funcionesActivadas = true;
    }

    desactivarFunciones(){

        this.funcionesActivadas = false;
    }

    onPaste(e: any) {

        e.preventDefault();
    }
    validarCompraVenta(){
      if(this.parametroUrl == ':parametro'){
        this.clienteProveedor='Proveedor'
      }else{
        this.clienteProveedor='Cliente'
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/pago-venta/pago-venta.component.ts